import { useMutation } from '@tanstack/react-query'
import { ExportsApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'

type Variables = {
  reportExportId: number
}

/**
 * レポート出力結果ファイルを署名付きURL経由でダウンロードする。
 *
 * presigned URL に Content-Disposition: attachment が付与されているため、
 * aTag.href へ直接指定してクリックすればブラウザがネイティブな
 * ダウンロードとして処理し、 blob をメモリに組み立てる必要がない。
 * ファイル名は S3 側のレスポンスヘッダで決まるが、 download 属性も同じ値を
 * セットしておく。
 */
export const useMutationDownloadFile = () => {
  return useMutation({
    mutationFn: async ({ reportExportId }: Variables) => {
      const { downloadUrl, downloadFileName } = await baseClient
        .getApi(ExportsApi)
        .getReportsExportDownload({
          exportId: String(reportExportId),
        })

      const aTag = document.createElement('a')
      aTag.href = downloadUrl
      aTag.download = downloadFileName
      document.body.appendChild(aTag)
      try {
        aTag.click()
      } finally {
        document.body.removeChild(aTag)
      }
    },
  })
}
